import { getServerUrl } from '../utils/getServerUrl';
import { useQuery } from '@tanstack/react-query';
import { readCookie } from '@zapier/cookies';
import { useUniversalNavContext } from './useUniversalNavContext';
async function fetchTeamTrialTreatmentData({ currentAccountId, customUserId, bffHostname, }) {
    var _a;
    const serverUrl = getServerUrl(bffHostname || '');
    const url = new URL(`${serverUrl}/api/v3/teams-trial-data/treatment`);
    const response = await fetch(url.toString(), {
        credentials: 'include',
        headers: {
            'x-current-account-id': (currentAccountId === null || currentAccountId === void 0 ? void 0 : currentAccountId.toString()) || '',
            'x-customuser-id': (customUserId === null || customUserId === void 0 ? void 0 : customUserId.toString()) || '',
            'x-visitor-id': (_a = readCookie('visitor_id')) !== null && _a !== void 0 ? _a : '',
        },
    });
    if (!response.ok) {
        throw new Error('Response was not OK');
    }
    const treatmentResponse = await response.json();
    return treatmentResponse;
}
export const useQueryTeamTrialTreatment = ({ currentAccountId, isTrialingTeams, }) => {
    const { bffHostname } = useUniversalNavContext();
    const query = useQuery({
        queryKey: ['team-trial-treatment', currentAccountId, isTrialingTeams],
        queryFn: () => fetchTeamTrialTreatmentData({
            currentAccountId,
            bffHostname,
        }),
        enabled: isTrialingTeams,
        refetchOnWindowFocus: false,
        retry: false,
    });
    return Object.assign(Object.assign({}, query), { isLoading: query.isInitialLoading });
};
//# sourceMappingURL=useQueryTeamTrialTreatment.js.map
// @zapier/universal-layout@12.1.15 (040754877)
